import React from 'react';
import { Modal } from 'src/client/components/modals/Modal/Modal';
import {
  PurchaseDownloadDropdownMenu,
  PurchaseOption,
} from '../dropdowns/DownloadDropdown/PurchaseDownloadDropdownMenu';

type Props = {
  purchaseOptions: Array<PurchaseOption>;
  show: boolean;
  onHide: () => void;
  onSelect: (purchaseOption: PurchaseOption) => void;
};

export const MoviePurchaseOptionsModal = (props: Props) => {
  const { show, onHide, purchaseOptions, onSelect } = props;

  return (
    <Modal show={show} onHide={onHide} dialogClassName="purchase-modal" modalBodyClassName="purchase-modal-body">
      <PurchaseDownloadDropdownMenu purchaseOptions={purchaseOptions} onClick={onSelect} />
    </Modal>
  );
};
